import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Button } from '@src/components/ui/button/button';
import { cn } from '@src/utils/ui';

export const ConfirmationDialog = ({
    open,
    content,
    onClose,
    onAgree,
    loading = false,
    cancelLabel = 'CANCEL',
    cancelProps = {},
    agreeLabel = 'YES'
}) => {
    const handleClose = (_event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            onClose(_event);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <DialogContent>
                <DialogContentText
                    id='alert-dialog-description'
                    className={cn('tw-text-[20px] tw-text-bcaa-grey-900', content.className)}
                >
                    {content.body}
                </DialogContentText>

                {content.description ? (
                    <DialogContentText
                        id='alert-dialog-description'
                        className={cn('tw-text-[16px] tw-text-bcaa-grey-900 tw-my-[8px]')}
                    >
                        {content.description}
                    </DialogContentText>
                ) : null}
            </DialogContent>
            <DialogActions>
                {onClose ? (
                    <Button
                        className={cn('tw-p-[8px] tw-text-[14px]')}
                        variant='text'
                        disabled={loading}
                        loadingPosition='start'
                        {...cancelProps}
                        onClick={onClose}
                    >
                        {cancelLabel}
                    </Button>
                ) : null}
                <Button
                    onClick={onAgree}
                    className={cn('tw-p-[8px] tw-text-[14px]')}
                    autoFocus
                    variant='contained'
                    loading={loading}
                    loadingPosition='start'
                >
                    {agreeLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    content: PropTypes.shape({
        body: PropTypes.node.isRequired,
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        className: PropTypes.string
    }).isRequired,
    onClose: PropTypes.func,
    onAgree: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    cancelLabel: PropTypes.string,
    cancelProps: PropTypes.object,
    agreeLabel: PropTypes.string
};
